import React, { useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';


import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';

import PaymentIcon from '@mui/icons-material/Payment';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';


import {  useSelector, useDispatch } from 'react-redux';
import { updatePaymentType } from 'store/actions/order';




const useStyles = makeStyles((theme) => ({
  formControl: {
   
  },
  button: {
    margin: theme.spacing(1, 1, 0, 0),
  },
}));

const Payments = (props) => {
  const { optional, restaurant, allowDeliveryCash = false } = props;

  const dispatch = useDispatch();

  const classes = useStyles();
  const [value, setValue] = React.useState('');
  const [error] = React.useState(false);
  const order = useSelector((state) => state.order);
  
  const setPaymentType = (type) => dispatch(updatePaymentType(type));

  const handleRadioChange = (event) => {
    setValue(event.target.value);
    setPaymentType(event.target.value);
  };

  useEffect(() => {
    if (order.paymentType) {
      setValue(order.paymentType);
    }
  }
  , [order.paymentType]);

  const isPaypalEnabled = () => {
    // console.log(restaurant.onlineSettings)
       if (restaurant && restaurant.onlineSettings && restaurant.onlineSettings.isPaypalEnabled === true) {
         return true;
       }
       return false;
  };


  return (
    <>
      <FormControl component="fieldset" error={error} className={classes.formControl} fullWidth>
        <FormLabel component="legend" sx={{ fontSize: '0.875rem', marginBottom: '4px' }}>
          Payment Method
        </FormLabel>
        <RadioGroup aria-label="quiz" name="quiz" value={value} onChange={handleRadioChange} sx={{ marginTop: '4px' }}>
          <FormControlLabel 
            value="card" 
            control={<Radio color="primary" size="small" />} 
            label={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <PaymentIcon fontSize="small" />
                <Typography variant="body2" sx={{ marginLeft: '4px' }}>Credit/Debit Card</Typography>
              </div>
            }
            sx={{ marginBottom: '-4px' }}
          />
          {restaurant && restaurant.onlineSettings && restaurant.onlineSettings.isWechatOnlinePaymentEnabled === true ?
            <FormControlLabel 
              value="wechatPay" 
              control={<Radio color="primary" size="small" />} 
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img alt='wechat pay' style={{width: 24, height: 24}} src='/images/icons/wechatpay.png'/>
                  <Typography variant="body2" sx={{ marginLeft: '4px' }}>WeChat Pay</Typography>
                </div>
              }
              sx={{ marginBottom: '-4px' }}
            /> : null
          } 
          {restaurant && restaurant.isHuePayEnabled === true ?
            <FormControlLabel
              value="alipay"
              control={<Radio color="primary" size="small" />}
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img alt='alipay' style={{width: 24, height: 24}} src='/images/icons/alipay.png'/>
                  <Typography variant="body2" sx={{ marginLeft: '4px' }}>Alipay</Typography>
                </div>
              }
              sx={{ marginBottom: '-4px' }}
            /> : null
          }
          {optional ?
            <FormControlLabel
              value="payAtCounter"
              control={<Radio color="primary" size="small" />}
              label={<Typography variant="body2">Pay at Counter</Typography>}
              sx={{ marginBottom: '-4px' }}
            /> : null}
          {allowDeliveryCash ?
            <FormControlLabel
              value="cash"
              control={<Radio color="primary" size="small" />}
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LocalAtmIcon fontSize="small" />
                  <Typography variant="body2" sx={{ marginLeft: '4px' }}>Cash on Delivery</Typography>
                </div>
              }
              sx={{ marginBottom: '-4px' }}
            /> : null}
          
          {isPaypalEnabled() ? 
            <FormControlLabel 
              value="paypal" 
              control={<Radio color="primary" size="small" />} 
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img alt='paypal' style={{width: 40, height: 40}} src='/images/icons/paypal.png'/>
                </div>
              }
              sx={{ marginBottom: '-4px' }}
            /> : null}
        </RadioGroup>
      </FormControl>
     </>
  )
}

Payments.propTypes = {
  optional: PropTypes.bool,
  allowDeliveryCash: PropTypes.bool,
  restaurant: PropTypes.shape({
    isHuePayEnabled: PropTypes.bool,
    onlineSettings: PropTypes.shape({
      isPaypalEnabled: PropTypes.bool,
      isWechatOnlinePaymentEnabled: PropTypes.bool,
    }),
  }),
};

export default Payments;
